/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { Group, GroupProps } from '@mantine/core'

function ButtonGroup (props: GroupProps) {
  const { children, ...others } = props
  return (
    <Group
      gap="sm"
      align="center"
      justify="end"
      {...others}
    >
      {children}
    </Group>
  )
}

export default ButtonGroup
